import { API_URL } from "../../config/index";
import API from "../../api/Routes";
import ACTION from "../../actions";
import ApiServices from "../../services/Api.services";
import { setItem, showErrorToast } from "../../utils/Functions";

export const generateOtp = (payload) => async (dispatch) => {
  try {
    await ApiServices.postApi(API_URL + API.GENERATE_OTP, payload).then(
      (response) => {
        // if (response.status === 1) {
        dispatch({
          type: ACTION.GENERATE_OTP,
          payload: response.data,
        });
        // }
      }
    );
  } catch (error) {
    showErrorToast(error);
  }
};

export const resetOtp = () => async (dispatch) => {
  dispatch({
    type: ACTION.RESET_OTP,
  });
};

export const login = (payload) => async (dispatch) => {
  try {
    await ApiServices.postApi(API_URL + API.LOGIN, payload).then((response) => {
      // if (response.status === 1) {
      dispatch({
        type: ACTION.LOGIN,
        payload: response.data,
      });
      let userData = response?.data?.data;
      setItem("User", JSON.stringify(userData));
      // }
      setItem("accessToken", response.data.token);
    });
  } catch (error) {
    showErrorToast(error);
  }
};

export const resetLogin = () => async (dispatch) => {
  dispatch({
    type: ACTION.RESET_LOGIN,
  });
};
